import { render, staticRenderFns } from "./SideCartNew.vue?vue&type=template&id=3c1c326b&scoped=true&"
import script from "./SideCartNew.vue?vue&type=script&lang=js&"
export * from "./SideCartNew.vue?vue&type=script&lang=js&"
import style0 from "./SideCartNew.vue?vue&type=style&index=0&id=3c1c326b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c326b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1c326b')) {
      api.createRecord('3c1c326b', component.options)
    } else {
      api.reload('3c1c326b', component.options)
    }
    module.hot.accept("./SideCartNew.vue?vue&type=template&id=3c1c326b&scoped=true&", function () {
      api.rerender('3c1c326b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/SideCartNew.vue"
export default component.exports